module.exports = __webpack_public_path__ + "fonts/Gilroy-Regular.22d25e11.ttf";